import actions from './actions';
import mutations from './mutations';
var state = {
  regions: [],
  sections: [],
  // users: [],
  tags: [],
  tags_org: [],
  categories: [],
  updateHours: []
};
export default {
  namespaced: true,
  state: state,
  actions: actions,
  mutations: mutations
};